class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.key, this.dataset.index, 0);

      // Get the Product ID
      let productID = this.closest('.cart-item').getAttribute('data-product-id');
      //console.log(productID);

      // Find any boost product grid items of the same ID and reset.
      const boostProductItems = document.querySelectorAll(`.boost-pfs-filter-product-item[data-id='${productID}']`);
      boostProductItems.forEach(function(boostProductItem) { // Probably only every 1 shown, but lets just loop it
        boostProductItem.classList.remove("boost-pfs-added");
        boostProductItem.classList.remove("limit-reached");
        boostProductItem.querySelector('.quantity__input').value = 1; // Reset incase user adds again
      });

      // Find any product page items of the same ID and reset.
      const productForm = document.querySelector(`.unero-single-product-detail product-form[data-id='${productID}']`);
      const productQty = document.querySelector(`.unero-single-product-detail .product-form__input[data-id='${productID}']`);
      const productPage = document.querySelector(`#product-${productID}`);

      // Find any Prev Purchased page items of the same ID and reset.
      const ppProductItems = document.querySelectorAll(`.pp-item[data-product-id='${productID}']`);

      //console.log(productPage);
      
      if(productForm) {
         productForm.classList.remove("hide");
         productQty.classList.add("hide");
         productQty.querySelector('.quantity__input').value = 1; // Reset incase user adds again
      }
      if(productPage) {
        productPage.classList.remove("limit-reached");
      }

      ppProductItems.forEach((ppProductItem) => {
        ppProductItem.classList.remove("is--in-cart");
        ppProductItem.querySelector('.pp-item__add-to-cart').classList.remove("hide");
        ppProductItem.querySelector('.pp-item__quantity').classList.add("hide");
        ppProductItem.querySelector('.quantity__input').value = 1; // Reset in case user adds again
    });

      if (productID = 8098124628275) {
        const membershipAddBtns = document.querySelectorAll(`.add_to_cart_button_membership`);
        membershipAddBtns.forEach(function(membershipAddBtn) { // Probably only every 1 shown, but lets just loop it
          membershipAddBtn.value = "Add Membership";
          membershipAddBtn.removeAttribute("disabled");
        });
      }


    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.isLoading = false; // Add loading state flag
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.key, event.target.dataset.line, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.mini-cart-counter'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(id, line, quantity, name) {
  console.log('updateQuantity for ' + name + ' to ' + quantity);

    this.enableLoading(line);

    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    $(".mini-cart-counter-circle").addClass("pulsating-cart");

    //console.log(body);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();


        setTimeout((function() {
            $(".mini-cart-counter-circle").removeClass("pulsating-cart")
        }), 100)

        
      }).catch(() => {

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();

        console.log('error updating cart: ' . errors.textContent);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    if (this.isLoading) return; // Prevent multiple simultaneous updates
    this.isLoading = true;

    // Disable again, incase user tries to change quantity again
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = 0.25;
    });
    console.log('cart changing');


    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.isLoading = false;
    
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      if (!button.hasAttribute('limit-reached')) {
        button.disabled = false;
        button.style.opacity = 1;
      }
    });
    console.log('cart ready');

    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};